/**
 * modals.js
 */

$(function () {

/**
 * Tasks Skip
 */
$('#taskSkipModal').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget);
  console.log("here");
  var task_id = button.data('task-id');
  var task_title = button.data('title');
  var task_description = button.data('description');

  var modal = $(this);
  modal.find('#title').text(task_title);
  modal.find('#description').text(task_description);
  modal.find('#taskSkipForm').attr('action', route('dash.tasks.update', task_id));
});

/**
 * Tasks Completion
 */
$('#taskConfirmModal').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget);
  console.log("here");
  var task_id = button.data('task-id');
  var task_title = button.data('title');
  var task_description = button.data('description');

  var modal = $(this);
  modal.find('#title').text(task_title);
  modal.find('#description').text(task_description);
  modal.find('#taskConfirmForm').attr('action', route('dash.tasks.update', task_id));
});

/**
 * Improvement Completion
 */
$('#improvementCompletionModal').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget);

  var improvement_id = button.data('improvement-id');
  var improvement_title = button.data('title');
  var improvement_notes = button.data('notes');
  var improvement_room = button.data('room');
  var improvement_type = button.data('type');

  var modal = $(this);
  modal.find('#title').text(improvement_title);
  modal.find('#notes').text(improvement_notes);
  if (improvement_room != '') {
    modal.find('#room').text('Room: ' + improvement_room);
  } else {
    modal.find('#room').text('');
  }
  modal.find('#improvementCompletionForm').attr('action', route('dash.improvements.update', improvement_id));
  modal.find('#type').val(improvement_type);

  setTimeout(() => {
    // needed a delay on this for this to work
    $('#completion_notes').focus();
  }, 500);
});

/**
 * Refund Booking To Voucher
 */
$('#refundBookingToVoucherModal').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget);

  var booking_id = button.data('booking-id');
  var reference = button.data('reference');
  var customer_name = button.data('customer-name');
  var room_name = button.data('room-name');
  var roomslot = button.data('roomslot');
  var players = button.data('players');
  var peak = button.data('peak');
  var sale_state = button.data('sale-state');
  var sale_money_taken = button.data('sale-money-taken');

  if (sale_state == 'COMPLETE') {
    var voucherText = 'The credit will be used to issue a new ' + peak + ' <strong>for ' + players + ' players</strong> to ' + customer_name;
    var moneyRefund = false;
  } else {
    var voucherText = 'The amount spent on this sale will be converted to a voucher (£' + (sale_money_taken / 100).toFixed(2) + ')';
    var moneyRefund = true;
  }

  var modal = $(this);
  modal.find('#reference').text(reference);
  modal.find('#room-name').text(room_name);
  modal.find('#roomslot').text(roomslot);
  modal.find('#peak').text(peak);
  modal.find('#players').text(players);
  modal.find('#customer-name').text(customer_name);
  modal.find('#voucher-to-refund').html(voucherText);
  modal.find('#refundBookingToVoucherForm').attr('action', route('dash.bookings.refund-to-voucher', booking_id));
});

/**
 * Procedure Upload
 */
$('#procedureUploadModal').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget);

  var procedure_id = button.data('procedure-id');
  var location_id = button.data('location-id');
  var procedure_title = button.data('title');
  var procedure_description = button.data('description');
  var procedure_category = button.data('category');
  var procedure_category_text = button.data('category-text');
  var procedure_location = button.data('location');
  var procedure_room = button.data('room');

  var modal = $(this);
  modal.find('#title').text(procedure_title);
  modal.find('#description').text(procedure_description);
  if (procedure_location != '') {
    modal.find('#location').text('Location: ' + procedure_location);
  } else {
    modal.find('#location').text('');
  }
  if (procedure_room != '') {
    modal.find('#room').text('Room: ' + procedure_room);
  } else {
    modal.find('#room').text('');
  }

  var params = {
    procedure: procedure_id
  }
  modal.find('#procedureUploadForm').attr('action', route('dash.procedures.procedures-storages.store', params));
});

/**
 * Game Timeline Adjust Upload
 */
$('#gameTimelineAdjustModal').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget);

  var timeline_id = button.data('timeline-id');
  var customer_name = button.data('customer-name');
  var room_name = button.data('room-name');
  var room_nickname = button.data('room-nickname');
  var datetime = button.data('datetime');

  var modal = $(this);
  modal.find('.modal-content').attr('class', 'modal-content bg-' + room_nickname);

  modal.find('#customer_name').text(customer_name);
  modal.find('#room_name').text(room_name);
  modal.find('#gameTime').val(datetime);

  var params = {
    gameTimeline: timeline_id,
  }
  modal.find('#gameTimelineAdjustForm').attr('action', route('dash.game-timelines.update-time', timeline_id));
});

/**
 * Virtual Game Marketing Details Copy
 */
$('#virtualGameCopyModal').on('show.bs.modal', function (event) {
  var button = $(event.relatedTarget);

  var virtualGameName = button.data('virtual-game-name');
  var virtualGameSlug = button.data('virtual-game-slug');

  var modal = $(this);

  modal.find('#virtualGameName').text(virtualGameName);

  modal.find('#virtualGameCopyForm').attr('action', route('dash.virtual-games.populate', virtualGameSlug));
});

// ===================

/**
 * Improvement Completion
 */
$('#inventoryProductCountModal').on('show.bs.modal', function (event) {
  console.log('#inventoryProductCountModal opened');
  var button = $(event.relatedTarget);

  var count_description = button.data('count-description');

  var able_id = button.data('able-id');
  var able_name = button.data('name');
  var able_amount = button.data('amount');
  var able_last_counted = button.data('last-counted');
  var able_last_count = button.data('amount');
  var consumable = button.data('consumable');
  var location_slug = button.data('location-slug');

  var modal = $(this);

  modal.find('.countDescription').text(count_description);

  modal.find('#name').text(able_name);
  modal.find('#itemCount').val(able_amount);
  modal.find('#lastCounted').text(able_last_counted);
  modal.find('#lastCount').text(able_last_count);

  if (count_description == 'Product') {
    modal.find('#inventoryProductCountForm').attr('action', route('dash.locations.product-stocktakes.update', {location: location_slug, product: able_id}));
  } else {
    modal.find('#consumable').val(consumable);
    modal.find('#inventoryProductCountForm').attr('action', route('dash.locations.inventory.update', {location: location_slug, inventoryItem: able_id}));
  }

});

}); // $(function () {
